import { Interweave } from 'interweave';
import React from 'react';
import { imagefilter } from './ImageFilter';
const SafeHTMLMarkdown = ({ message, attributes }) => {
    return React.createElement(Interweave, { content: message, attributes: attributes, filters: [imagefilter] });
};
export default SafeHTMLMarkdown;
